import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import api from "../redux/api";
import { getInProgress, getSelectedFileId } from "../redux/selectors";
import Folder from "./folder";
const mapStateToProps = (state) => ({
    selectedFileId: getSelectedFileId(state),
    inProgress: getInProgress(state)
});
const mapDispatchToProps = (dispatch) => ({
    onDeleteFile: (folderId, fileId, documentId) => {
        dispatch(actionCreators.deleteFile(fileId, folderId, documentId));
    },
    onSelectFile: (folderId, documentId, fileId) => {
        dispatch(actionCreators.setFileId(folderId, documentId, fileId));
    },
    onDownloadFile: (fileId) => {
        dispatch(actionCreators.downloadFile(fileId));
    },
    onBuildFileUrl: (file) => api.onBuildFileUrl(file)
});
export default connect(mapStateToProps, mapDispatchToProps)(Folder);
